import React, { useCallback } from 'react';

import { MaterialBrandID } from '../../../../../../materials/materialsTypes';

import { ThreeDStockMaterialsCompactListItemInfoMaterial } from './ThreeDStockMaterialsCompactListItemInfo.types';

import { NextLinkHelper } from '../../../../../../../helpers/links/NextLinkHelper';
import { Translate } from '../../../../../../../helpers/Translate';
import { PureButtonHelper } from '../../../../../../../helpers/buttons/PureButtonHelper';

import { MaterialPath } from '../../../../../../materials/MaterialPath';
import { words } from '../../../../../../../locales/keys';

interface ThreeDStockMaterialsCompactListItemInfoProps {
  material: ThreeDStockMaterialsCompactListItemInfoMaterial;
  onMaterialBrandButtonClick?: (brandId: MaterialBrandID) => void;
}

function ThreeDStockMaterialsCompactListItemInfo({
  material,
  onMaterialBrandButtonClick
}: ThreeDStockMaterialsCompactListItemInfoProps) {
  const handleBrandButtonClick = useCallback(() => {
    onMaterialBrandButtonClick?.(material.brand?.id);
  }, [material.brand?.id, onMaterialBrandButtonClick]);

  return (
    <div className="flex-1 min-w-20 px-3 py-2 text-sm flex flex-col items-start gap-0.5">
      <NextLinkHelper
        className="font-semibold truncate max-w-full"
        dataGa="materials-material-goto-material-page-link"
        href={MaterialPath.show(material.nanoId)}
      >
        <div className="absolute inset-0 z-1" />
        {material.name}
      </NextLinkHelper>

      <div className="flex gap-2">
        {material.nda && (
          <span className="bg-yellow-200 text-black px-1 text-xs rounded uppercase">
            <Translate id={words.nda} />
          </span>
        )}

        {material.brand?.localizedName && (
          <PureButtonHelper
            className="text-gray-500 dark:text-gray-400 relative z-[2] hover:text-gray-800 dark:hover:text-gray-200 truncate max-w-full"
            text={material.brand?.localizedName}
            onClick={handleBrandButtonClick}
          />
        )}
      </div>
    </div>
  );
}

export default ThreeDStockMaterialsCompactListItemInfo;
